<footer class="web-footer">
  <div class="footer-container">
    <div class="footer-column" *ngFor="let column of columns">
      <ul class="footer-list">
        <li class="footer-list-item" *ngFor="let link of column">
          <a
            class="footer-link"
            [href]="link.href"
            target="_blank"
            rel="noopener noreferrer">
            {{ link.label }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</footer>
